const initialState = {
  userSettings: [],
  showChatbotConnectionError: false,
  chatbotRetryCount: 0,
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'SET_ADMIN_USER_SETTINGS': {
      return {
        ...state,
        userSettings: action.payload,
      }
    }
    case 'SET_SHOW_CHATBOT_CONNECTION_ERROR': {
      return {
        ...state,
        showChatbotConnectionError: action.payload,
      }
    }
    case 'SET_CHATBOT_RETRY_COUNT': {
      return {
        ...state,
        chatbotRetryCount: action.payload,
      }
    }
    default:
      return state
  }
}

export default reducer
